// Manage CSS
import '@scss/manage/index.scss';
// Manage Icons
import './_icons';
// Modals
import { Modal } from '@ts/components/Modal';

// Section Specific Imports
import { init as initAccount } from "./account";
import { init as initCreateFundraiser } from './createFundraiser';
import { init as initManageFundraiser } from './manageFundraiser';
import { init as initEarlyAccess } from '../shop/earlyAccess';

document.addEventListener("DOMContentLoaded", () => {
    initAccount();
    initCreateFundraiser();
    initManageFundraiser();
    setModalTriggers();
    initEarlyAccess();
    setModalTriggers();
});

const setModalTriggers = () => {    
    Modal.setModalTriggers(); 
}